// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__1BANs","modalForm":"UpgradeEpcsModal_modalForm__3vXkp","modalFooter":"UpgradeEpcsModal_modalFooter__1yTc_"};